<template>
  <footer class="footer">
    <div class="footerWarp">
      <div class="contain">
        <el-row class="el-row-warp">
          <el-col :span="20">
            <ul class="footerNav">
              <li v-for="item in footerNavList" :key="item.id">
                <div
                  v-if="item.url && item.url !== 'javascript:;'"
                  class="name"
                >
                  <span v-if="item.url.indexOf('{website}') === 0">
                    <router-link
                      :to="{ path: $util.getParenthesesStr(item.url) }"
                      :target="item.openType === 1 ? '_self' : '_blank'"
                      :title="item.name"
                    >
                      {{ item.name }}</router-link>
                  </span>
                  <span v-else-if="item.url">
                    <a
                      :href="item.url | urlAddToken"
                      :target="item.openType === 1 ? '_self' : '_blank'"
                      :title="item.name"
                    >{{ item.name }}</a>
                  </span>
                  <span v-else>
                    <a href="javascript:void(0);" :title="item.name">{{
                      item.name
                    }}</a>
                  </span>
                </div>
                <div v-else class="name">
                  <a href="javascript:void(0);" :title="item.name">{{
                    item.name
                  }}</a>
                </div>

                <ul v-if="item.subList.length > 0">
                  <li v-for="subitem in item.subList" :key="subitem.id">
                    <div v-if="subitem.url && subitem.url !== 'javascript:;'">
                      <span v-if="subitem.url.indexOf('{website}') === 0">
                        <router-link
                          :to="{ path: $util.getParenthesesStr(subitem.url) }"
                          :target="subitem.openType === 1 ? '_self' : '_blank'"
                          :title="subitem.name"
                        >
                          {{ subitem.name }}</router-link>
                      </span>
                      <span v-else-if="subitem.url">
                        <a
                          :href="subitem.url | urlAddToken"
                          :target="subitem.openType === 1 ? '_self' : '_blank'"
                          :title="subitem.name"
                        >{{ subitem.name }}</a>
                      </span>
                      <span v-else>
                        <a href="javascript:void(0);" :title="subitem.name">{{
                          subitem.name
                        }}</a>
                      </span>
                    </div>
                    <div v-else>
                      <a href="javascript:void(0);" :title="subitem.name">{{
                        subitem.name
                      }}</a>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </el-col>
          <el-col :span="4">
            <div v-if="portalInfo.wechatUrl" class="wechat">
              <img :src="portalInfo.wechatUrl" width="88">
              <div>关注官方微信</div>
            </div>
            <div v-show="portalInfo.qq" class="qq">
              QQ：{{ portalInfo.qq }}
            </div>
            <div v-show="portalInfo.email" class="email">
              邮箱：{{ portalInfo.email }}
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="copyright">
      <div class="copyrightLeftContent">
        <!-- <div class="center">
          <a
            class="bszs"
            href="https://bszs.conac.cn/sitename?method=show&id=054F139EFDEB4FCEE06310291AAC7673"
            target="_blank"
          ><img
            id="imgConac"
            vspace="0"
            hspace="0"
            border="0"
            src="https://dcs.conac.cn/image/red_error.png"
            data-bd-imgshare-binded="1"
            height="35"
          ></a>
        </div> -->
        <div class="copyrightItem">
          <span v-show="portalInfo.name" :title="portalInfo.name">主办单位：{{ portalInfo.name }}</span>
          <span v-show="portalInfo.serviceTel" :title="portalInfo.serviceTel">联系电话：{{ portalInfo.serviceTel }}</span>
        </div>
        <div class="copyrightItem">
          <span v-show="portalInfo.portalIcp" :title="portalInfo.portalIcp">备案许可证编号：<a href="https://beian.miit.gov.cn" target="_blank">{{ portalInfo.portalIcp }}</a>
          </span>
        </div>
        <div class="copyrightItem">
          <span
            v-show="portalInfo.footCopyright"
            :title="portalInfo.footCopyright"
          >技术支持：{{ portalInfo.footCopyright }}
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AppFooter',
  computed: {
    ...mapGetters(['portalInfo', 'footerNavList'])
  }
};
</script>
<style lang="scss" scoped>
.footer {
  background: #4e657a;
  color: #fff;
  // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);

  .footerWarp {
  }

  .contain {
    margin: 0 auto;
    // width: 100%;
    // max-width: 80%;
    width: 1200px;
  }

  .copyright {
    text-align: center;
    padding: 40px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .copyrightItem {
      width: 1200px;
      margin: 10px auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    a.bszs {
      // position: absolute;
      // right: 50%;
      // transform: translate(calc(-50% + 240px));
      // z-index: 9;

      img {
        height: 72px;
        object-fit: contain;
      }
    }

    span {
      width: 260px;
      white-space: nowrap;
      -o-text-overflow: ellipsis;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: middle;
      display: inline-block;
      -webkit-line-clamp: 1;
      text-align: left;
    }
  }

  .wechat {
    text-align: center;
    font-size: 12px;
    line-height: 24px;
    padding-top: 42px;
  }

  .email,
  .qq {
    text-align: center;
    max-width: 200px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    vertical-align: middle;
    -webkit-line-clamp: 1;
  }

  .footerNav {
    li {
      vertical-align: top;
      display: inline-block;
      font-size: 18px;
      padding: 42px;

      div.name {
        font-weight: bold;

        span a {
          height: 24px;
          line-height: 24px;
          display: block;
        }
      }

      ul {
        margin-top: 10px;

        li {
          display: block;
          font-size: 14px;
          line-height: 24px;
          padding: 0px;
        }
      }
    }
  }
}
</style>
